// MAPVIEW
export const INIT_MAP = 'INIT_MAP';
export const SET_TOAST_ERROR = 'SET_TOAST_ERROR';
export const SET_MAPVIEW_READY = 'SET_MAPVIEW_READY';
export const UPDATE_VISIBLE_LAYERS = 'UPDATE_VISIBLE_LAYERS';
export const UPDATE_DISABLED_LAYERS = 'UPDATE_DISABLED_LAYERS';
export const SET_SKETCH_TOOL_ACTIVE = 'SET_SKETCH_TOOL_ACTIVE';
export const SET_DRAW_COMPLETE = 'SET_DRAW_COMPLETE';
export const SET_ANNOTATION_TOOL_ACTIVE = 'SET_ANNOTATION_TOOL_ACTIVE';
export const UPDATE_ANNOTATIONS = 'UPDATE_ANNOTATIONS';
export const SET_CONTEXTUAL_TOOL_ACTIVE = 'SET_CONTEXTUAL_TOOL_ACTIVE';
export const SET_RIVER_TOOL_ACTIVE = 'SET_RIVER_TOOL_ACTIVE';
export const UPDATE_MY_LAYERS = 'UPDATE_MY_LAYERS';
export const TOGGLE_MAP_LOADER = 'TOGGLE_MAP_LOADER';
export const UPDATE_PERFORM_AUDIT_LAYERS = 'UPDATE_PERFORM_AUDIT_LAYERS';
export const SET_LAYER_MODAL_ACTIVE = 'SET_LAYER_MODAL_ACTIVE';
export const STORE_TEMP_GRAPHIC = 'STORE_TEMP_GRAPHIC';
export const SET_SWIPE_TOOL_ACTIVE = 'SET_SWIPE_TOOL_ACTIVE';
export const UPDATE_THRESHOLDS = 'UPDATE_THRESHOLDS';
export const SET_RENDERING_RULE = 'SET_RENDERING_RULE';
export const SET_TIMESLIDERS_ENABLED = 'SET_TIMESLIDERS_ENABLED';

// AUDIT DATA
export const SET_AUDIT_AREA = 'SET_AUDIT_AREA';
export const SET_CONTEXTUAL_AREA = 'SET_CONTEXTUAL_AREA';
export const SET_IMAGE_PAIR = 'SET_IMAGE_PAIR';
export const REMOVE_IMAGE_PAIR = 'REMOVE_IMAGE_PAIR';
export const CLEAR_IMAGE_PAIRS = 'CLEAR_IMAGE_PAIRS';
export const SET_TIMELINE_OPEN = 'SET_TIMELINE_OPEN';
export const SET_TIME_BEING_SELECTED = 'SET_TIME_BEING_SELECTED';
export const SET_CURRENT_SELECTED_IMAGE = 'SET_CURRENT_SELECTED_IMAGE';
export const CLEAR_CURRENT_SELECTED_IMAGE = 'CLEAR_CURRENT_SELECTED_IMAGE';
export const CLEAR_CURRENT_IMAGE_PAIR = 'CLEAR_CURRENT_IMAGE_PAIR';
export const SET_CREATING_RIVER_BOUNDARIES = 'SET_CREATING_RIVER_BOUNDARIES';
export const SET_MERGE_INTERSECT_LAYERS = 'SET_MERGE_INTERSECT_LAYERS';
export const SET_MERGE_INTERSECT_OPERATION = 'SET_MERGE_INTERSECT_OPERATION';

// LEFT PANEL
export const TOGGLE_LOADER = 'TOGGLE_LOADER';
export const SET_BUFFER_DISTANCE = 'SET_BUFFER_DISTANCE';
export const SET_BUFFER_UNIT = 'SET_BUFFER_UNIT';
export const SET_TIMELINE_DATES = 'SET_TIMELINE_DATES';
